import { createSelector } from 'reselect';
import { fromJS } from 'immutable';
import { formValueSelector } from 'redux-form';
import { getSizeChartDetails } from '../../ProductDetail/container/ProductDetail.selectors';

export const bundleProduct = (state) => {
  return state.BundleProduct;
};

export const selectDesignYourBagState = (state) => state.DesignYourBag;

const selectState = (state) => state;

export const getCurrentProduct = createSelector(
  bundleProduct,
  (currentBundle) => currentBundle?.currentProduct
);

export const currentColorFitSizeMap = createSelector(getCurrentProduct, (product) =>
  product?.colorFitsSizesMap?.map((color) => fromJS(color))
);

export const currentImagesByColor = createSelector(
  getCurrentProduct,
  (product) => product?.imagesByColor
);

export const currentAlternateBrand = createSelector(
  bundleProduct,
  (currentBundle) => currentBundle?.alternateBrand
);

export const selectCurrentColorEntry = createSelector(
  bundleProduct,
  (currentBundle) => currentBundle?.currentColorEntry
);

export const selectCurrentSizeList = (state, productId) => {
  const designYourBagState = selectDesignYourBagState(state);
  return designYourBagState[productId].sizeList;
};

export const selectFormValues = (state, uniqueId, field) => {
  const designYourBagState = selectDesignYourBagState(state);
  const formName = designYourBagState && designYourBagState[uniqueId]?.formName;
  const selector = formValueSelector(formName);
  return selector(state, ...field);
};

export const getAddToCollectionList = (state) => {
  const designYourBagState = selectDesignYourBagState(state);
  const collections = designYourBagState?.collections || [];

  if (collections?.length > 0) {
    return collections.map((collection) => {
      const { formValues, productId, department, uniqueKey, variantID } = collection || {};
      const data = designYourBagState?.[`${department}-${productId}`];
      const { product } = data || {};

      return {
        product,
        formValues,
        department,
        uniqueKey,
        productId,
        variantID,
      };
    });
  }

  return [];
};

export const selectSizeChartDetails = createSelector(selectState, (state) =>
  getSizeChartDetails(state)
);

export const selectCollectionList = createSelector(
  selectDesignYourBagState,
  (designYourBag) => designYourBag?.collections || []
);
